<template>
  <div class="about">
    <span style="color: #000">.</span>

    <div class="row" style="margin-top:75px;">
      <h1>This is an about page :)</h1>
    </div>
  </div>
</template>
